import './UserSettings.scss';

import { AccountInformation } from './AccountInformation';
import { ChangePassword } from './ChangePassword';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CurrentUserEmail } from './Email';
import { EditAvatar } from './EditAvatar';
import { PreferenceToggles } from './PreferenceToggles';
import React from 'react';

import { Col, Row } from 'antd';
import { SonarCard, ViewArea } from '@ui/general';

export const UserSettings: React.FC = () =>
	<ViewArea
		direction='vertical'
		fullWidth
		id='user-settings'>
		<SonarCard title={ COPY_SPECIFIC.USER_SETTINGS }>
			<Row>
				<Col>
					<EditAvatar />
				</Col>
				<Col className='settings-panel'>
					<CurrentUserEmail />
					<AccountInformation />
					<PreferenceToggles />
					<ChangePassword />
				</Col>
			</Row>
		</SonarCard>
	</ViewArea>;

